import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit';
import { getSecondaryOfferingData } from '../../services/secondaryOfferings/secondaryOfferingSection';
const initialState = {
  loading: true,
  sliderData: {},
  webData: {},
  mobileData: {},
};
export const fetchSecondaryOfferingListAction = createAsyncThunk('FETCH_SECONDARY_OFFERING_LIST', getSecondaryOfferingData);
export const fetchSecondartOfferingWebListAction = createAsyncThunk('FETCH_SECONDARY_OFFERING_WEB_LIST', getSecondaryOfferingData);
export const fetchSecondaryOfferingMobileListAction = createAsyncThunk('FETCH_SECONDARY_OFFERING_MOBILE_LIST', getSecondaryOfferingData);

export const secondaryOfferingSlice = createSlice({
  name: 'propertyDetails',
  initialState,
  reducers: {
    updateSecondaryPropertyList: (state, action) => {
      state.sliderData = {...action.payload};
    },
    updateWebSecondaryPropertyList: (state, action) => {
      state.webData = {...action.payload};
    },
    updateMobileSecondaryPropertyList: (state, action) => {
      state.mobileData = {...action.payload};
    }
  },
  extraReducers: {
    [fetchSecondaryOfferingListAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [fetchSecondaryOfferingListAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
        sliderData: action.payload,
        webData: action.payload,
        mobileData: action.payload,
      };
    },
    [fetchSecondaryOfferingListAction.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        data: {},
      };
    },

    //featching web initial page data
    [fetchSecondartOfferingWebListAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [fetchSecondartOfferingWebListAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
        webData: action.payload,
      };
    },
    [fetchSecondartOfferingWebListAction.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        data: {},
      };
    },

    //featching mobile data
    [fetchSecondaryOfferingMobileListAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [fetchSecondaryOfferingMobileListAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
        mobileData: {
          ...current(state.mobileData),
          data: {
            ...current(state.mobileData.data),
            properties: current(state.mobileData.data.properties).concat(action.payload.data.properties),
          },
        },
      };
    },
    [fetchSecondaryOfferingMobileListAction.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        data: {},
      };
    },
  },
});

export const { 
  updateSecondaryPropertyList,
  updateWebSecondaryPropertyList,
  updateMobileSecondaryPropertyList
} = secondaryOfferingSlice.actions;
const { reducer } = secondaryOfferingSlice;
export default reducer;
